import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import urlTemplate from 'url-template';
import { createReducer, createSelector } from '@reduxjs/toolkit';
import createAction from './createAction';
export var initialState = {};
export var setDomain = createAction('domain/setDomain');
export function initDomain() {
  return function (dispatch, getState, context) {
    if (context.isServer && !context.hasPreloadedState) {
      var domain = context.req.context.domain;
      dispatch(setDomain(domain));
    }
  };
}
export var getDomainRedirectFunction = createSelector([function (state) {
  return state.domain;
}], function (domain) {
  var template = urlTemplate.parse(domain.template);
  return function (inputValues) {
    if (typeof inputValues === 'string') {
      inputValues = {
        domain: inputValues
      };
    }

    var values = _objectSpread({
      subdomain: domain.subdomain,
      name: domain.name,
      tld: domain.tld
    }, inputValues);

    if (!values.domain) {
      values.domain = [values.subdomain || '', values.name || '', values.tld || ''].join('');
    }

    if (!values.pathname) {
      values.pathname = '/';
    }

    if (typeof values.hash === 'string') {
      if (values.hash === '') {
        values.hash = null;
      } else if (values.hash.startsWith('#')) {
        values.hash = values.hash.slice(1);
      }
    }

    return template.expand(values);
  };
});
export var domainReducer = createReducer(initialState, _defineProperty({}, setDomain, function (state, action) {
  return action.payload;
}));
export default {
  id: 'domain',
  reducerMap: {
    domain: domainReducer
  },
  initialActions: [initDomain()]
};